import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import './MarkdownParagraph.less'

interface MarkdownParagraphProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownParagraph: FC<MarkdownParagraphProps> = ({
                                                                  block,
                                                                  onToggleCheckBox
                                                              }) => {
    return (
        <div className="block paragraph">
            <AtomsViewer atoms={block.atoms} separator={<br/>} onToggleCheckBox={onToggleCheckBox}/>
        </div>
    )
}
